import React from 'react';
import './PasswordDetail.css';

const DeleteConfirmationModal = ({ visible, onConfirm, onCancel, loading }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="password-modal">
      <h3>确认删除密码?</h3>
      <div className="button-container">
        <button onClick={onConfirm} disabled={loading}>
          {loading ? '删除中...' : '确认'}
        </button>
        <button onClick={onCancel}>取消</button>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
